// extracted by mini-css-extract-plugin
export default {"header":"idLWA","successActions":"S1M8D","desktop":"Gr9j4","title":"RAV78","mobile":"ptCgt"};